<template>
  <div class="flex flex-col items-start gap-12">
    <div
      class="flex w-full flex-col gap-0 xl:flex-row xl:items-start xl:gap-12"
    >
      <div
        class="flex w-full max-w-3xl grow flex-col justify-start gap-6"
      >
        <slot />
      </div>
      <div class="sticky top-24 flex flex-col items-start gap-10">
        <slot name="sidebar" />
      </div>
    </div>
  </div>
</template>
